import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../analytics';

/**
 * GoogleAnalytics
 * ===============
 * Mounted once inside <BrowserRouter>. Fires exactly one GA4 page_view on the
 * initial render and on every client-side route change (pathname/search/hash).
 * gtag.js is loaded in public/index.html with send_page_view:false so this is
 * the single source of page-view events.
 */
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Title updates happen in RouteAwareSeo/Helmet; defer a tick so page_title
    // reflects the new route.
    const id = window.setTimeout(trackPageView, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default GoogleAnalytics;
